const middleware = {}

middleware['web-redirect'] = require('../middleware/web-redirect.js')
middleware['web-redirect'] = middleware['web-redirect'].default || middleware['web-redirect']

export default middleware
